import { ILayoutProps } from "../types";
import { buildUrl } from "components/Template/web";
import { IImage } from "components/Template/types";
import { doHidden } from "components/Template/utils";
import Validate from "components/Template/Validate";
import "./Image.scss";

export interface IImageProps extends ILayoutProps {
  template: IImage;
}

const Image = (props: IImageProps) => {
  const { template, model, mutators, result, metadata } = props;
  const { getValue } = mutators;

  if (doHidden(props)) {
    if (!metadata.hiddenInput.includes(template.name)) {
      metadata.hiddenInput.push(template.name);
    }
    return null;
  } else {
    if (metadata.hiddenInput.includes(template.name)) {
      metadata.hiddenInput = metadata.hiddenInput.filter((i) => i === template.name);
    }
  }

  const url = buildUrl(model, template.url, getValue, result);
  const alt = template.label || template.description || "";

  return (
    <Validate {...props} className="image" showLabel showInfo>
      <img
        src={url}
        alt={alt}
        {...(template?.width ? { width: template?.width } : {})}
        {...(template?.height ? { height: template?.height } : {})}
      />
    </Validate>
  );
};

export default Image;
